export const getChatUserId = (user: unknown) => {
  if (!user || typeof user !== 'object') {
    return '';
  }

  const typed = user as { sub?: string; email?: string };
  return typed.sub ?? typed.email ?? '';
};
